import React, { Fragment, useEffect, useState } from 'react';
import { contents } from '../../../Utils/options';
import MenuCard from './MenuCard';
import menuImage from 'Assets/img/svg/menuImage.svg';
import { useStyles } from './menu.style';
import Header from 'Components/Header/Header';
import { CommonButtonTypes } from 'Common/Types/Types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import profileMobileBg from 'Assets/img/svg/profile/bgMobile.svg';
import milestoneMobileBg from 'Assets/img/svg/milestone/bgMobile.svg';
import activitiesMobileBg from 'Assets/img/svg/activities/bgMobile.svg';
import shopToysMobileBg from 'Assets/img/svg/shopToys/bgMobile.svg';
import recoursesMobileBg from 'Assets/img/svg/resources/bgMobile.svg';
import exerciseMobileBg from 'Assets/img/svg/exercises/bgMobile.svg';
import { RootState } from 'ReduxStore';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { GetProfile } from 'ReduxStore/profile/Action';
import { Routes } from 'Utils';
import ConditionalCard from '../Cards/ConditionalCard';
import CustomModal from 'Components/Modals/CustomModal';
import{ conditions }from 'Utils/options'
import Activity from 'Assets/img/holders/Activity.svg';
import M from 'Assets/img/holders/M.svg';
import MilestoneImage from 'Assets/img/holders/milestones.svg'
import { getToy } from 'ReduxStore/toys/Action';
import nn from 'Assets/img/nn.svg'
const Menu = ({ common }: CommonButtonTypes) => {
	const classes = useStyles({ common });
	const matches = useMediaQuery('(max-width:440px)');
	const dispatch = useDispatch();
	const history = useHistory();
	const   [name,setName] = useState<any>('')
	const [open,setOpen] = useState<boolean>(false);
	const [image, setImage] = useState<any>('');
	const [displayWarning, setDisplayWarning] = useState<any>('')
	const toys = useSelector((state: RootState) => state.toys.toy);
	const [ clickedLink,setClickedLink] = useState<string>('')
	useEffect(() => {
		const getProfile = async () => GetProfile()(dispatch);
		getProfile();
		dispatch(getToy());
		setName(localStorage.getItem('currentChild'));
		process.env.REACT_APP_NODE_ENV != 'development' ?   setDisplayWarning(toys?.showQuestionarre) : setDisplayWarning(true)
	}, []);
	const getChildId = localStorage.getItem('currentChildId');
	const children = useSelector((state: RootState) => state.children.children);
	const child = children && children.find(child => child.id === (getChildId && parseInt(getChildId)));
	

	const handleModalClick = (condition: string) =>
		condition === 'yes' ? history.push(`/address/${child?.id}`) : setOpen(false);

	const newContents = contents.map(content => {
		const then =
			content.type === 'Profile'
				? profileMobileBg
				: content.type === 'Milestones'
				? milestoneMobileBg
				: content.type === 'Activities'
				? activitiesMobileBg
				: content.type === 'Resources'
				? recoursesMobileBg
				: content.type === 'Shop toys'
				? shopToysMobileBg 
				: content.type === 'Exercises'
				? exerciseMobileBg
				: ' ';
		return {
			...content,
			childSubscription: child && child?.Subscriptions.length > 0 ? true : false,
			backgroundImage: matches ? then : content.backgroundImage,
		};
	});
	const modalHandler = (contentUrl:string,external:boolean) => {
		if (!external){
			// add a check if user has a premium subscription then show the modal else redirect - handle in a ternary operator!
			setClickedLink(contentUrl)
			const isSubscribed = child && child?.Subscriptions.length > 0 ? history.push(contentUrl) : setOpen(!open) ;
			return contentUrl ===  Routes.MilestoneCategories   ?  isSubscribed  : contentUrl === Routes.Process ? isSubscribed  : history.push(contentUrl);
		}
		return window.open('https://www.adventuretowntoys.com/', '_blank');
		
	}
	return (
		<Fragment>
			<div className="">
				<Header setName={setName}/>
				<div className={`${classes.menuHeaderBackground} d-flex flex-row justify-content-center`} />
				<img src={menuImage} alt="" className={classes.menuHeaderImage} />
				<div className={classes.greetingInformation}>
					<h3 className={classes.greetings}>Greetings, {name}! </h3>
					<small>
					Let’s see how we can help you today.  Select from the menu below to start planning your day.
					</small>
					{
						displayWarning ? (<small>
							<h5 style={{color:'red'}}> {`It is time to fill out the Questionnaire regarding ${name}'s experience with this month's toy. Click on the Activities tab and scroll to the bottom. We need this information in order to ship the next toy in a timely manner.`}</h5>
						</small>) : ''
					}
				</div>
			</div>
			<ul className={classes.listItems}>
				{newContents.map(content => (
					<li key={content.id} className="my-4 " >
						{
							
							<MenuCard
								externalLink={content.external}
								url={ content.url}
								image={content.backgroundImage}
								type={content.type}
								width={content.width}
								description={content.description}
								icon={content.icon}
								isMenu
								onClick={modalHandler}
								// no={content.id}
							/>
						}
					</li>
				))}
			</ul>
			{ open ? (
					<CustomModal open={open} >
						<ConditionalCard
							information= { clickedLink ===  Routes.MilestoneCategories ? `Become a member to manage your child's milestones.` : `Become a Premium Member to receive a monthly box of
							tools and toys tailored your child's individual needs.
							`} 
							heading={`Well, hello there!`}
							conditions={conditions}
							image={ clickedLink === Routes.MilestoneCategories ? MilestoneImage : Activity}
							onClick={handleModalClick}
						>
							<p style={{ color: '#E1705A'}}>Would you like to join?</p>
							</ConditionalCard>
					</CustomModal>
				) : (
					''
				)}
		</Fragment>
	);
};

export default Menu;
